// extracted by mini-css-extract-plugin
export default {"root":"CopyMultipleModalAdditionalContent_root__ZaHFC","placeHolderShimmer":"CopyMultipleModalAdditionalContent_placeHolderShimmer__INA9j"};